import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { Typography } from '@components/Typography';
import { Select } from '@components/Select';
import UnverifiedBadge from '@components/UnverifiedBadge';
import { useTranslation } from '@hooks';
import { LINK_VALUE, SKIP_VALUE, CREATE_VALUE } from './constants';

const Row = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) 280px',
    gap: 24,
    alignItems: 'start',
    padding: '16px 0',
    '& + &': {
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    },
    '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
        gap: 12,
    },
});

const Info = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
    minWidth: 0,
});

const Header = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    maxWidth: '100%',
});

const Avatar = styled('img')({
    width: 24,
    height: 24,
    borderRadius: '50%',
    flexShrink: 0,
});

const SubText = styled(Typography)({
    color: 'var(--text-secondary)',
});

const Controls = styled('div')({
    minWidth: 0,
});

const Options = styled(RadioGroup)({
    gap: 4,
});

const Option = styled(FormControlLabel)({
    margin: 0,
    '& .MuiFormControlLabel-label': {
        fontSize: 14,
        color: 'var(--text-primary)',
    },
});

const SmallRadio = styled(Radio)({
    padding: 4,
    marginRight: 4,
});

const ProfileRow = ({
    profile,
    mode,
    location,
    options,
    showCreate,
    createDisabled,
    onModeChange,
    onLocationChange,
    disabled,
}) => {
    const { t } = useTranslation();

    return (
        <Row>
            <Info>
                <Header>
                    {profile.avatar && <Avatar src={profile.avatar} alt="" />}
                    <Typography variant="subtitle2">{profile.title}</Typography>
                </Header>
                {profile.subtitle && <SubText variant="caption">{profile.subtitle}</SubText>}
                {profile.address && <SubText variant="caption">{profile.address}</SubText>}
                {profile.unverified && <UnverifiedBadge />}
            </Info>
            <Controls>
                <Options value={mode} onChange={e => onModeChange(profile.key, e.target.value)}>
                    <Option
                        value={LINK_VALUE}
                        disabled={disabled}
                        control={<SmallRadio size="small" />}
                        label={t('SettingsIntegrations.manageIntegration.connectToLocation')}
                    />
                    {mode === LINK_VALUE && (
                        <Select
                            groupBased
                            required
                            style={{ width: '100%' }}
                            options={options}
                            value={location}
                            onChange={e => onLocationChange(profile.key, e.target.value)}
                            disabled={disabled}
                            label={t('common.location')}
                        />
                    )}
                    <Option
                        value={SKIP_VALUE}
                        disabled={disabled}
                        control={<SmallRadio size="small" />}
                        label={t('SettingsIntegrations.manageIntegration.dontConnect')}
                    />
                    {showCreate && (
                        <Option
                            value={CREATE_VALUE}
                            disabled={disabled || createDisabled}
                            control={<SmallRadio size="small" />}
                            label={t('SettingsIntegrations.manageIntegration.createNew')}
                        />
                    )}
                </Options>
            </Controls>
        </Row>
    );
};

export default ProfileRow;
